import React from 'react';

import dayjs from 'dayjs';

import type {
  AirdropClaimRecordRowsItem,
  AirdropClaimRecordType,
  AirdropSendRecordRowsItem,
  AirdropSendRecordType
} from '@api/index';
import { ScrollLoading } from '@components/index';
import { Timeline } from '@components/Timeline';

import { AirCard } from '../../airCard';

import styles from './index.module.less';

interface HistoryMainProps {
  fetchMoreHistoryData: () => void;
  historyData: AirdropClaimRecordType | AirdropSendRecordType;
}

export const HistoryMain: React.FC<HistoryMainProps> = (props) => {
  const { fetchMoreHistoryData, historyData } = props;
  const itemss = React.useMemo(() => {
    // https://juejin.cn/post/6961459233892073503
    const rows: (AirdropClaimRecordRowsItem | AirdropSendRecordRowsItem)[] =
      historyData?.rows;

    const _items = rows?.reduce((prev, cur) => {
      const time =
        (cur as { receiveTime?: number }).receiveTime ||
        (cur as { releaseTime?: number }).releaseTime;

      const curTime = dayjs(time).format('YYYY / MM');

      const _prev = [...prev];
      if (!_prev.length) {
        // 第一次循环需要push{}
        _prev.push({ content: [], time: curTime });
      }
      if (curTime === _prev[_prev.length - 1].time) {
        _prev[_prev.length - 1].content.push(<AirCard {...cur} />);
      } else {
        _prev.push({ content: [] });
        _prev[_prev.length - 1].time = curTime;
        _prev[_prev.length - 1].content.push(<AirCard {...cur} />);
      }
      return _prev;
    }, []);
    return _items;
  }, [historyData]);

  return (
    <div className={styles.container}>
      <ScrollLoading fetchData={fetchMoreHistoryData} invisibleHeight={100}>
        <Timeline
          items={itemss}
          contentContainerClassName={styles.contentContainer}
        />
      </ScrollLoading>
    </div>
  );
};
